import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import { Outlet } from 'react-router';

import { MessageHandler } from '../features/livemonitor/MessageHandler';

const WidgetLayout = () => (
    <ApplicationLayout>
        <Outlet />
        <MessageHandler />
    </ApplicationLayout>
);

export default WidgetLayout;
